export const contactData = {
  location: "Ivry-sur-seine",
  email: "leanne.lpzs@gmail.com",
};

export const experiencesData = [
  {
    title: "Graphiste & Motion designer",
    company: "Sciences Po, Paris",
    years: "2024 - 2026",
  },
  {
    title: "Graphiste",
    company: "Association Tisseco Solidaire, Montreuil",
    years: "2020 - 2023",
  },
  {
    title: "Motion designer",
    company: "Ministère des Outre-mer, Paris",
    years: "2019 - 2020",
  },
  {
    title: "Graphiste",
    company: "Association La boîte à Emplois, Pontault-Combault",
    years: "2019",
  },
];

export const formationsData = [
  {
    title: "Bachelor Designer en communication graphique écoresponsable",
    school: "Campus Fonderie de l'Image, Bagnolet",
    years: "2024 - 2026",
  },
  {
    title: "Formation web",
    school: "OpenClassrooms, Paris",
    years: "2022 - 2023",
  },
  {
    title: "Post-diplôme Digital Média Lab",
    school: "EPSAA, Ivry-sur-Seine",
    years: "2020 - 2021",
  },
  {
    title: "Bachelor Design 3D & Animation",
    school: "ICAN, Paris",
    years: "2017 - 2020",
  },
  {
    title: "Licence 1 de Philosophie",
    school: "La Sorbonne, Paris I",
    years: "2016 - 2017",
  },
];

export const inspirationsData = [
  {
    title: "Chant Maluf",
    location: "Centre Paris Anim’, Paris",
    years: "2025 - 2026",
  },
  {
    title: "Judo",
    location: "Centre Paris Anim’, Paris",
    years: "2025 - 2026",
  },
  {
    title: "Jiu-jitsu Brézilien",
    location: "Flow Jiu-jitsu, Ivry-sur-Seine",
    years: "2025 - 2026",
  },
  {
    title: "Oud",
    location: "Centre Paris Anim’, Paris",
    years: "2024 - 2026",
  },
  {
    title: "Danse Orientale contemporaine",
    location: "Pocket Café, Montreuil",
    locationSecond: "2023 - 2026",
    years: "Maison Populaire, Montreuil",
  },
  {
    title: "Danse Odissi",
    location: "Micadanses, Paris",
    years: "2023 - 2026",
  },
  {
    title: "Danse Bollywood traditionnelle",
    location: "Maison Populaire, Montreuil",
    years: "2022 - 2025",
  },
  {
    title: "Danse Salsa",
    location: "La Sorbonne, Paris",
    years: "2016 - 2017",
  },
  {
    title: "Tir à l’arc classique",
    location: "Compagnie d’arc, Mitry-Mory",
    locationSecond: "2015 - 2018",
    years: "3e départemental junior",
  },
  {
    title: "Danse Modern Jazz",
    location: "Conservatoire municipal, Mitry-Mory",
    years: "2010 - 2016",
  },
  {
    title: "Violon",
    location: "Conservatoire municipal, Mitry-Mory",
    years: "2013 - 2015",
    locationSecond: "Conservatoire départemental, Aulnay-sous-bois",
    yearsSecond: "2004 - 2009",
  },
];
